export default "__VITE_ASSET__1392a3ff__"